import { createFileRoute } from '@tanstack/react-router';
import PalmaTermsPage from '@/pages/static/PalmaTermsPage';

export const Route = createFileRoute('/palma/terms')({
  component: PalmaTermsPage,
});
